export function getStoredToken() {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem('token') || window.localStorage.getItem('auth-token') || null;
}

export function syncStoredToken(token) {
  if (typeof window === 'undefined' || !token) return;
  window.localStorage.setItem('token', token);
  window.localStorage.setItem('auth-token', token);
}

export function syncStoredSession({ token, user, tenant }) {
  if (typeof window === 'undefined') return;
  if (token) syncStoredToken(token);
  if (user) window.localStorage.setItem('user', JSON.stringify(user));
  if (tenant) window.localStorage.setItem('tenant', JSON.stringify(tenant));
}

export function clearStoredSession() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem('token');
  window.localStorage.removeItem('auth-token');
  window.localStorage.removeItem('user');
  window.localStorage.removeItem('tenant');
}
